import React, {useEffect, useState }   from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button         from '@material-ui/core/Button';
import TextField      from '@material-ui/core/TextField';
import MenuItem       from '@material-ui/core/MenuItem';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid           from '@material-ui/core/Grid'
import FamikarHeader  from '../components/FamikarHeader';
import firebase       from 'firebase/compat/app';
import 'firebase/compat/auth';

/**
 * FamilyRegist: 家族メンバー登録・編集コンポーネント
 *
 * 役割:
 * - 家族メンバーの追加・編集・削除を行うフォームを提供
 * - 画像選択・サムネイル生成、入力バリデーション、Firestoreへの反映を制御
 *
 * 主な状態:
 * - `displayName`, `selectedGender`, `birthYear/birthMonth/birthDay`: 基本プロフィール
 * - `allergy`, `history1`, `regularDrug`, `normal_tmp1`, `bloodType`, `Height`, `Weight`: 医療関連情報
 * - `image_src`, `image_change`: 画像選択と加工の状態
 * - `memberID`, `familyID`, `uid`, `isEdit`: 編集対象や遷移に必要な情報
 */
export default function FamilyRegist(props){
  const navigate = useNavigate()
  const location = useLocation()
  // let now = new Date(2015, 6, 1)
  let now = new Date()
  const yearList = []
  const monthList = []
  const dayList = []
  const tmp1List = []
  const heightList = []
  const weightList = []
  let deleteButton = null

  const [ modalShow,        setModalShow        ] = useState(false)
  const [ newRegist,        setNewRegist        ] = useState(true)
  const [ memberName,                           ] = useState((location.state !== null && location.state.memberName  !== '') ? location.state.memberName : '')
  const [ memberUrl,                            ] = useState((location.state !== null && location.state.memberUrl   !== '') ? location.state.memberUrl  : '')
  const [ memberID,         setMemberID         ] = useState((location.state !== null && location.state.memberID    !== '') ? location.state.memberID   : '')
  const [ familyID,         setFamilyID         ] = useState((location.state !== null && location.state.familyID    !== '') ? location.state.familyID   : '')
  const [ uid,              setUid              ] = useState((location.state !== null && location.state.uid         !== '') ? location.state.uid        : '')
  const [ isEdit,           setIsEdit           ] = useState((location.state !== null && typeof location.state.isEdit === 'boolean') ? location.state.isEdit : false)
  const [ isSubmitting,     setIsSubmitting     ] = useState(false)
  const [ displayName,      setDisplayName      ] = useState('')
  const [ selectedGender,   setSelectedGender   ] = useState('選択してください')
  const [ birthYear,        setBirthYear        ] = useState(now.getFullYear())
  const [ birthMonth,       setBirthMonth       ] = useState(now.getMonth()+1)
  const [ birthDay,         setBirthDay         ] = useState(now.getDate())
  const [ allergy,          setAllergy          ] = useState('')
  const [ history1,         setHistory1         ] = useState('')
  const [ regularDrug,      setRegularDrug      ] = useState('')
  const [ normal_tmp1,      setNormal_tmp1      ] = useState('')
  const [ bloodType,        setBloodType        ] = useState('')
  const [ Height,           setHeight           ] = useState('')
  const [ Weight,           setWeight           ] = useState('')
  const [ image_src,        setImage_src        ] = useState('')
  const [ image_change,     setImage_change     ] = useState(false)

  // console.log("state.memberName:" + memberName)
  // console.log("state.memberUrl:" + memberUrl)
  // console.log("state.memberID:" + memberID)
  // console.log("state.familyID:" + familyID)
  // console.log("state.uid:" + uid)
  // console.log("state.isEdit:" + isEdit)
  // console.log(location.state)
  for( let i = now.getFullYear() - 110; i <= now.getFullYear(); i++ ){
    yearList.push(<MenuItem key={i} value={i}>{i}</MenuItem>)
  }

  for( let m = 1; m <= 12; m++ ){
    monthList.push(<MenuItem key={m} value={m}>{m}</MenuItem>)
  }

  for( let n = 1; n <= 31; n++ ){
    dayList.push(<MenuItem key={n} value={n}>{n}</MenuItem>)
  }

  for ( let k=35.0; k < 42.1; k=k+0.1 ){
    var tmperatureStr = k.toFixed(1)
    tmp1List.push(<MenuItem key={tmperatureStr} value={tmperatureStr}>{tmperatureStr}</MenuItem>)
  }

  for( let h=30; h <= 200; h++ ){
    heightList.push(<MenuItem key={h} value={h}>{h}</MenuItem>)
  }

  for( let w=0; w <= 200; w++ ){
    weightList.push(<MenuItem key={w} value={w}>{w}</MenuItem>)
  }

  if (isEdit === true) {
    // 編集
    deleteButton = (
      <Grid item>
        <Button variant="outlined" style={{margin: '0 8px', padding: '5px 20px', color: '#FFF', backgroundColor: '#F66', border: '1px solid #F00'}} onClick={()=>handleDelete()}>削除</Button>
      </Grid>
    )
  } else {
    // 新規
    deleteButton = null
  }

  /**
   * 必須パラメータの初期化:
   * - `uid`/`familyID` が未設定の場合、認証ユーザーと `Person/{uid}` から補完
   * - 未ログイン時は `/Login` へ遷移
   * - `memberID` が存在し、`isEdit` が未設定の場合は編集モードへ切替
   */
  const initRequiredParams = async () => {
    try {
      const authUser = await new Promise((resolve) => {
        firebase.auth().onAuthStateChanged((user) => resolve(user || null))
      })
      if (!authUser) {
        navigate('/Login')
        return
      }
      if (!uid) {
        setUid(authUser.uid)
      }
      if (!familyID) {
        const personSnap = await firebase.firestore().collection('Person').doc(authUser.uid).get()
        const data = personSnap.data()
        const firstFamily = data && Array.isArray(data.FamilyID) ? data.FamilyID[0] : undefined
        if (firstFamily && firstFamily.id) {
          setFamilyID(firstFamily.id)
        }
      }
      // ルート直アクセスなどで memberID が存在し、isEdit が未設定の場合は編集モード
      if (memberID && !isEdit) {
        setIsEdit(true)
      }
    } catch (e) {
      console.log('FamilyRegist initRequiredParams error:', (e && (e.code || e.message)) || e)
    }
  }

  useEffect(() => {
    // 初回マウント時に必須パラメータを補完
    initRequiredParams()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => { //ページ表示時、情報更新時に実行
    /**
     * 初回マウント時処理:
     * - 編集モードなら対象メンバーの情報を読み込み、モーダルを表示
     */
    // componentDidMount のタイミングで実行したい処理を記述
    if(isEdit === true){
      showEditModal(memberID,familyID,true)
    }
    // 次の行のコメントでeslintの余分なワーニングを抑制する。
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, memberID, familyID]);

  //表示名
  const handleDisplayNameChange =(e) =>{
    setDisplayName(e.target.value)
  }
  //性別
  const handleGenderChange =(e) =>{
    setSelectedGender(e.target.value)
  }
  //生年月日　年
  const handleBirthYearChange =(e) =>{
    setBirthYear(e.target.value)
  }
  //生年月日　月
  const handleBirthMonthChange =(e) =>{
    setBirthMonth(e.target.value)
  }
  //生年月日　日
  const handleBirthDayChange =(e) =>{
    setBirthDay(e.target.value)
  }
  //アレルギー
  const handleAllergyChange =(e) =>{
    setAllergy(e.target.value)
  }
  //病歴1
  const handleHistory1Change =(e) =>{
    setHistory1(e.target.value)
  }
  //飲んでるお薬　2020.7.28 arai 追加
  const handleRegularDrugChange =(e) =>{
    setRegularDrug(e.target.value)
  }
  //平熱
  const handleNormalTmp1Change =(e) =>{
    setNormal_tmp1(e.target.value)
  }
  //身長
  const handleHeightChange =(e) =>{
    setHeight(e.target.value)
  }
  //体重
  const handleWeightChange =(e) =>{
    setWeight(e.target.value)
  }
  //血液型
  const handleBloodTypeChange =(e) =>{
    setBloodType(e.target.value)
  }

  //家族登録アクション
  const handleRegistClick = async (e) => {
    /**
     * 登録ボタン押下:
     * - 必須項目のバリデーションを行い、`registMember(false)` を実行
     * - 成功時にアラート表示し家族ホームへ遷移
     *
     * 【処理フロー（同期/非同期の順序）】
     * 1) 二重押下防止（isSubmitting が true なら何もしない）
     * 2) 入力バリデーション
     * 3) isSubmitting=true にして登録処理へ
     * 4) registMember(false) を await（画像アップロードがある場合も完了/失敗まで待つ）
     * 5) 成功: 「登録しました」→ 家族ホームへ遷移
     * 6) 失敗: エラーメッセージ表示 → この画面に留まる（編集画面へ戻る）
     */
    console.log("MemberRegistCard.js handleRegistClick check")

    if (isSubmitting) {
      return
    }

    // 必須項目チェック
    if (displayName === null || displayName === '') {
      alert("名前を入れてください")
      return
    }
    if (birthYear === null || birthYear === '') {
      alert("生年月日を入れてください")
      return
    }
    if (birthMonth === null || birthMonth === '') {
      alert("生年月日を入れてください")
      return
    }
    if (birthDay === null || birthDay === '') {
      alert("生年月日を入れてください")
      return
    }
    // if (selectedGender === null || selectedGender === '' || selectedGender === '選択してください') {
    //   alert("性別を選択してください")
    //   return
    // }
    // 空文字チェック
    if (allergy === null) {
      //this.state.allergy = ''
      setAllergy('')
    }
    if (history1 === null) {
      //this.state.history1 = ''
      setHistory1('')
    }
    if (regularDrug === null) {
      //this.state.regularDrug = ''
      setRegularDrug('')
    }

    console.log("MemberRegistCard.js handleRegistClick start")
    console.log("MemberRegistCard.js handleRegistClick registMemberCall")
    try {
      setIsSubmitting(true)
      await registMember(false)
      console.log("MemberRegistCard.js handleRegistClick onEventCallback")
      alert("登録しました")
      navigate('/FamilyHome/' + familyID)
    } catch (error) {
      console.log('MemberRegistCard.js handleRegistClick error:', error)
      if (error && (error.code === 'IMAGE_UPLOAD_FAILED' || error.message === 'IMAGE_UPLOAD_FAILED')) {
        alert('画像のアップロードに失敗しました。通信状況を確認してもう一度お試しください。')
      } else {
        alert('登録に失敗しました。通信状況を確認してもう一度お試しください。')
      }
    } finally {
      setIsSubmitting(false)
    }
  }


  //家族登録処理
  const registMember = async (isDelete) => {
    /**
     * メンバー登録/更新処理:
     * - `isDelete` が true の場合は削除フラグを立てて更新
     * - 編集モードでは既存 `Member/{memberID}` を `set()` で更新
     * - 新規モードでは `Member` に `add()` して新しい `memberID` を取得
     * - 画像が選択されている場合は Storage にアップロードし、URL を Firestore に反映
     * @param {boolean} isDelete 削除フラグ
     * @returns {Promise<void>}
     *
     * 【処理フロー（重要：画像アップロードの成功/失敗と、Firestore書き込みの順序）】
     * A) uid / familyID の補完（未設定なら auth + Person から取得）
     * B) 編集/新規の判定
     *    - 編集: 既存の Member/{memberID} を対象
     *    - 新規: doc() でIDだけ先に発行し、まだ Firestore に書き込まない
     *      （画像アップロード失敗時に "メンバーだけ作成される" 途中状態を残さないため）
     * C) 画像が変更された場合（image_change===true かつ image_src あり）
     *    1) canvas から base64 を生成
     *    2) Storage へアップロード（最大3回試行＝リトライ2回）
     *    3) 成功したら DownloadURL を取得し finalImageUrl に反映
     *    4) 3回失敗したら IMAGE_UPLOAD_FAILED を throw
     * D) Firestore への書き込み（画像アップロードが必要な場合は "アップロード成功後" に実行）
     *    - 編集: set(..., {merge:true})
     *    - 新規: set(...)
     * E) ここで throw された場合は handleRegistClick 側で catch され、エラー表示して画面に留まる
     */
    console.log("registMember() start!!")
    var db = firebase.firestore()

    // 念のため必須値を補完（state の set は即時反映されないためローカル変数で保持する）
    let effectiveUid = uid
    let effectiveFamilyId = familyID
    if (!effectiveUid) {
      const authUser = firebase.auth().currentUser
      if (!authUser) {
        throw new Error('not authenticated')
      }
      effectiveUid = authUser.uid
      setUid(authUser.uid)
    }
    if (!effectiveFamilyId) {
      const docObj = await db.collection("Person").doc(effectiveUid).get()
      const data = docObj.data()
      const firstFamily = data && Array.isArray(data.FamilyID) ? data.FamilyID[0] : undefined
      effectiveFamilyId = (firstFamily && firstFamily.id) ? firstFamily.id : ''
      if (effectiveFamilyId) {
        setFamilyID(effectiveFamilyId)
      }
    }

    if (!effectiveFamilyId) {
      throw new Error('familyID is empty')
    }

    console.log("registMember() get db object uid:" + effectiveUid)
    console.log("get family id success:" + effectiveFamilyId)

    console.log("member db create start")
    console.log("  modalShow:" + modalShow)
    console.log("  newRegist:" + newRegist)
    console.log("  memberName:" + memberName)
    console.log("  familyID:" + effectiveFamilyId)
    console.log("  memberID:" + memberID)
    console.log("  displayName:" + displayName)
    console.log("  selectedGender:" + selectedGender)
    console.log("  allergy:" + allergy)
    console.log("  history1:" + history1)
    console.log("  regularDrug:" + regularDrug)
    console.log("  birthYear:" + birthYear)
    console.log("  birthMonth:" + birthMonth)
    console.log("  birthDay:" + birthDay)
    console.log("  normal_tmp1:" + normal_tmp1)
    console.log("  bloodType:" + bloodType)
    console.log("  Height:" + Height)
    console.log("  Weight:" + Weight)
    console.log("  isDelete:" + isDelete)
    // var memberID = memberID

    const isEditMode = (isEdit === true)
    const shouldUploadImage = (image_change === true && image_src !== "")

    const baseMemberData = {
      Allergy:           allergy,
      BirthDay:          new Date( birthYear, birthMonth - 1 , birthDay ),
      BloodType:         bloodType,
      DeleteFlag:        isDelete,
      DisplayName:       displayName,
      Gender:            selectedGender,
      Height:            Number(Height),
      MedicalHistory:    history1,
      NormalTemperature: Number(normal_tmp1),
      RegularDrug:       regularDrug,
      UpdateTime:        firebase.firestore.FieldValue.serverTimestamp(),
      Weight:            Number(Weight),
    }

    let targetMemberId = memberID
    let memberDocRef = null

    if (isEditMode) {
      console.log("Edit mode")
      if (!targetMemberId) {
        throw new Error('memberID is empty in edit mode')
      }
      memberDocRef = db.collection("Family").doc(effectiveFamilyId).collection("Member").doc(targetMemberId)
    } else {
      console.log("Create mode")
      // まず docID だけ生成（画像アップロード失敗時に Firestore に残さないため）
      memberDocRef = db.collection("Family").doc(effectiveFamilyId).collection("Member").doc()
      targetMemberId = memberDocRef.id
      setMemberID(targetMemberId)
    }

    // 画像が変更されている場合は「先にアップロード」し、成功したURLだけを Firestore に保存する
    let finalImageUrl = image_src
    if (shouldUploadImage) {
      console.log("image upload start:" + image_src)
      const cv_image_obj = document.getElementById('cv_image')
      if (!cv_image_obj) {
        const err = new Error('IMAGE_UPLOAD_FAILED')
        err.code = 'IMAGE_UPLOAD_FAILED'
        throw err
      }

      const base64Data = cv_image_obj.toDataURL("image/jpeg")
      const base64Payload = base64Data.split(',')[1] || ''
      const approxBytes = Math.floor((base64Payload.length * 3) / 4)
      console.log(`base64 length=${base64Data.length} payloadBytes~=${approxBytes}`)

      const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
      const awaitUploadTask = (uploadTask) => new Promise((resolve, reject) => {
        uploadTask.on(
          'state_changed',
          () => {},
          (error) => reject(error),
          () => resolve(uploadTask.snapshot)
        )
      })

      // Firebase Storage SDK 自身の長いリトライでブロックしないよう、時間上限を短めにする
      try {
        firebase.storage().setMaxUploadRetryTime(2000)
        firebase.storage().setMaxOperationRetryTime(2000)
      } catch (e) {
        // 環境により未対応の場合があるため無視
      }

      const storageRef = firebase.storage().ref('member_icon')
      const mountainImagesRef = storageRef.child(targetMemberId)

      let lastUploadError = null
      // 最大3回試行（=リトライ2回）
      for (let attempt = 1; attempt <= 3; attempt++) {
        try {
          console.log(`image upload attempt ${attempt}/3`)
          const uploadTask = mountainImagesRef.putString(base64Data, 'data_url')
          await awaitUploadTask(uploadTask)
          finalImageUrl = await firebase.storage().ref('member_icon').child(targetMemberId).getDownloadURL()
          setImage_src(finalImageUrl)
          console.log(finalImageUrl)
          lastUploadError = null
          break
        } catch (uploadError) {
          lastUploadError = uploadError
          console.log("image upload error: ", uploadError)
          if (attempt < 3) {
            // ちょい待って再試行（指数バックオフ気味）
            await sleep(300 * attempt)
          }
        }
      }

      if (lastUploadError) {
        const err = new Error('IMAGE_UPLOAD_FAILED')
        err.code = 'IMAGE_UPLOAD_FAILED'
        err.original = lastUploadError
        throw err
      }
    }

    // ここから Firestore 書き込み（画像アップロード成功後）
    if (isEditMode) {
      await memberDocRef.set({
        ...baseMemberData,
        image_url: finalImageUrl,
      }, { merge: true })
      console.log("member update successful")
    } else {
      await memberDocRef.set({
        ...baseMemberData,
        image_url: finalImageUrl,
        CreateTime: firebase.firestore.FieldValue.serverTimestamp(),
      })
      console.log("member added successful")
      console.log("memberID:" + targetMemberId)
    }
    setModalShow(false)
  }

  const handleImageFileChange = async(e)=>{
    /**
     * 画像ファイル選択ハンドラ:
     * - 選択画像のプレビューURLを作成し、`draw()` でサムネイル生成
     * @param {React.ChangeEvent<HTMLInputElement>} e ファイル入力イベント
     */
    // TODO 縦長のスマホなどで撮影した画像が横向きになる問題あり
    // https://qiita.com/mo49/items/a3d61d97f1883ead333b
    var createObjectURL = (window.URL || window.webkitURL).createObjectURL || window.createObjectURL;

    var files = e.target.files;
    var image_url = files.length===0 ? "" : createObjectURL(files[0]);
    setImage_src(image_url)
    setImage_change(true)

    await draw(image_url)
  }

  const handleGoBack = (e) =>{
    /**
     * キャンセル（戻る）:
     * - ブラウザ履歴を1つ戻す
     */
    navigate(-1)
  }

  const showEditModal = async (member, familyID, isShow) => {
    /**
     * 編集モーダル表示と初期化:
     * - `Member/{member}` を読み込み、状態へ反映
     * - 画像は `draw()` でサムネイルを生成
     * @param {string} member 対象メンバーID
     * @param {string} familyID 対象家族ID
     * @param {boolean} isShow モーダル表示フラグ
     */
    console.log("MemberRegistCard.js showEditModal called member["+member+"] isShow["+isShow+"] familyID["+familyID+"]")
    if (typeof member === 'undefined') {
      console.log("新規登録では起動時のfirestoreアクセスしない")
      return
    }
    var db = firebase.firestore()
    setModalShow(isShow)
    setMemberID(member)
    setFamilyID(familyID)
    setNewRegist(false)
    setImage_change(false)

    await db.collection("Family").doc(familyID).collection("Member").doc(member)
    .get()
    .then(async(result)=>{
      var data = result.data()
      var birthDate = (data.BirthDay === null) ? null : data.BirthDay.toDate()
      setAllergy((data.Allergy === null) ? '' : data.Allergy)
      setBirthYear((birthDate === null) ? '' : birthDate.getFullYear())
      setBirthMonth((birthDate === null) ? '' : birthDate.getMonth()+1)
      setBirthDay((birthDate === null) ? '' : birthDate.getDate())
      setBloodType((data.BloodType === null) ? '' : data.BloodType)
      setDisplayName((data.DisplayName === null) ? '' : data.DisplayName)
      setSelectedGender((data.Gender === null) ? '' : data.Gender)
      setHeight(data.Height)
      setImage_src(data.image_url)
      setNormal_tmp1(data.NormalTemperature)
      setHistory1((data.MedicalHistory === null) ? '' : data.MedicalHistory)
      setRegularDrug((data.RegularDrug === null) ? '' : data.RegularDrug)
      setWeight(data.Weight)
      await draw(data.image_url)
    })
    .catch(function(error) {
      console.log("Error getting family member add: ", error);
    });
  }
  
  const draw = async (imagePath) => {
    /**
     * 画像サムネイル生成:
     * - 画像の縦横比に応じてキャンバスサイズを調整し、縮小描画
     * @param {string} imagePath 画像URL
     */
    console.log("draw(" + imagePath + ")")
    const canvas = document.getElementById("cv_image");
    if( canvas == null ) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0,0,canvas.width,canvas.height);

    if(imagePath !== '')
    {
      const image = new Image();
      image.addEventListener("load",function (){
      //var file = null; // 選択ファイルが格納される変数
      //var blob = null; // 画像(BLOBデータ)が格納される変数
      const THUMBNAIL_MAX_WIDTH = 124; // 画像がヨコ長の場合、横サイズがこの値になるように縮小される
      const THUMBNAIL_MAX_HEIGHT = 124; // 画像がタテ長の場合、縦サイズがこの値になるように縮小される
      
      // 縮小後のサイズを計算する
      var width, height;
      if(image.width > image.height){
        // ヨコ長の画像は横サイズを定数にあわせる
        var ratio = image.height/image.width;
        console.log("横長"+ratio)
        width = THUMBNAIL_MAX_WIDTH;
        height = THUMBNAIL_MAX_WIDTH * ratio;
      } else {
        // タテ長の画像は縦のサイズを定数にあわせる
        //var ratio = image.width/image.height;
        ratio = image.width/image.height;
        console.log("縦長"+ratio)
        width = THUMBNAIL_MAX_HEIGHT * ratio;
        height = THUMBNAIL_MAX_HEIGHT;
      }
      console.log("width["+width+"] height["+height+"]")
  
      canvas.width = width;
      canvas.height = height;
  
      ctx.drawImage(image,
        0, 0, image.width, image.height,
        0, 0, width, height
      );
      });
      image.src = imagePath;
    }

  }

  const handleRegistFamilyImage = (e) =>{
    /**
     * 画像選択トリガー:
     * - 隠しファイル入力をクリックして画像選択ダイアログを開く
     */
    var btn_input_file = document.getElementById('file_familyImage');
    btn_input_file.click();
  }

  const handleDelete = (e) =>{
    /**
     * 削除ボタン押下:
     * - 確認ダイアログ表示後、`registMember(true)` を実行
     * - 成功時はアラート表示し、前画面へ戻る
     */
    // 削除実行の確認用ポップアップ
    if (!window.confirm("削除します")) {
      alert("削除をキャンセルしました")
      navigate(-1)
      return
    }

    // 削除ボタンは新規登録時に表示しないので入力チェックはしない
    console.log("MemberRegistCard.js handleDelete start")

    console.log("MemberRegistCard.js handleDelete registMemberCall")
    registMember(true).then((result)=>{
      console.log("MemberRegistCard.js handleDelete onEventCallback")

      alert("削除しました")
      navigate(-1)
    });
  }

  return (
    <React.Fragment>
      {uid !== '' ? <FamikarHeader uid={uid} FamilyID={familyID} isHome={true} /> : null}
      <div style={{display: 'block', background: 'white', textAlign:"left", margin:10}}>
        {/* <form className={this.props.classes.root} noValidate autoComplete="off" > */}
        <form style={{height: '800px'}} noValidate autoComplete="off" >
          <Grid container spacing={2} >
            <Grid container spacing={3} style={{padding: '8px'}}>
              <Grid item xs={4}>
                <div>
                  <Button variant="outlined" color="primary" style={{ width: 130, height: 130, position: 'relative', textAlign: 'center' }} onClick={()=>{handleRegistFamilyImage()}} >
                  {/* <Button variant="outlined" color="primary" style={{ width: 130, height: 130, position: 'relative', textAlign: 'center' }} > */}
                    画像を選ぶ
                    <canvas id="cv_image" width="0" height="0" style={{ position: 'absolute', textAlign: 'center' }}
                      src={memberUrl} />
                  </Button>
                </div>
                <div>
                  <input type="file" id="file_familyImage" accept=".jpg,.jpeg,.png" style={{ display: 'none' }} onChange={(e)=>{handleImageFileChange(e)}} />
                </div>
              </Grid>
              <Grid item xs={5}>
                <TextField id="tf_display_name" className="w-100" label="表示するお名前" value={displayName} onChange={(e) => handleDisplayNameChange(e)} />
              </Grid>
              {/* <Grid item xs={0}>
              </Grid> */}
              <Grid item xs={3}>
                <TextField select id="sel_gender" label="性別" className="w-100"
                  value={selectedGender} onChange={(e) => handleGenderChange(e)}>
                  {/* <MenuItem key='0' value='選択してください' >選択してください</MenuItem> */}
                  <MenuItem key='0' value='選択してください' ></MenuItem>
                  <MenuItem key='1' value='男性' >男性</MenuItem>
                  <MenuItem key='2' value='女性' >女性</MenuItem>
                  <MenuItem key='9' value='その他' >その他</MenuItem>
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                  <Grid item xs={3}>
                    <TextField select id="sel_birth_year" label="生年月日" className="w-100px" value={birthYear}
                      onChange={(e) => handleBirthYearChange(e)} InputProps={{startAdornment: <InputAdornment position="start" >年</InputAdornment>}}>
                      {yearList}
                    </TextField>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField select id="sel_birth_month" label=" " className="w-100px" value={birthMonth}
                      onChange={(e) => handleBirthMonthChange(e)} InputProps={{startAdornment: <InputAdornment position="start" >月</InputAdornment>}}>
                      {monthList}
                    </TextField>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField select id="sel_birth_day" label=" " className="w-100px" value={birthDay}
                      onChange={(e) => handleBirthDayChange(e)} InputProps={{startAdornment: <InputAdornment position="start" >日</InputAdornment>}}>
                      {dayList}
                    </TextField>
                  </Grid>
                  <Grid item xs={3}>
                    <TextField select id="sel_bloodType" label="血液型" className="w-100" value={bloodType} onChange={(e) => handleBloodTypeChange(e)}>
                      <MenuItem key='0' value='選択してください' ></MenuItem>
                      <MenuItem key='A' value='A' >A型</MenuItem>
                      <MenuItem key='O' value='O' >O型</MenuItem>
                      <MenuItem key='B' value='B' >B型</MenuItem>
                      <MenuItem key='AB' value='AB' >AB型</MenuItem>
                      <MenuItem key='A-' value='A-' >A型(Rh-)</MenuItem>
                      <MenuItem key='O-' value='O-' >O型(Rh-)</MenuItem>
                      <MenuItem key='B-' value='B-' >B型(Rh-)</MenuItem>
                      <MenuItem key='AB-' value='AB-' >AB型(Rh-)</MenuItem>
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <Grid container direction="row" justifyContent="space-between" alignItems="flex-start" spacing={1}>
                <Grid item xs={2}>
                  <TextField select id="sel_height" label="身長"  className="w-70px" value={Height} onChange={(e)=>handleHeightChange(e)}>
                    {heightList}
                  </TextField>
                </Grid>
                <Grid item xs={2} style={{textAlign: "left"}}>
                  cm
                </Grid>
                <Grid item xs={2}>
                  <TextField select id="sel_weight" label="体重"  className="w-70px" value={Weight} onChange={(e)=>handleWeightChange(e)}>
                    {weightList}
                  </TextField>
                </Grid>
                <Grid item xs={2}>
                  kg
                </Grid>
                <Grid item xs={2}>
                  <TextField select id="sel_normal_tmp1" label="平熱"  className="w-70px" value={normal_tmp1} onChange={(e)=>handleNormalTmp1Change(e)}>
                    {tmp1List}
                  </TextField>
                </Grid>
                <Grid item xs={2}>
                  ℃
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <TextField id="tf_allegy" className="w-100" label="アレルギー" value={allergy} onChange={(e)=>handleAllergyChange(e)} />
            </Grid>
            <Grid item xs={12}>
              <TextField id="tf_regularDrug" className="w-100" label="普段飲んでるお薬" multiline minRows='4' style={{height:120}} value={regularDrug} onChange={(e)=>handleRegularDrugChange(e)} />
            </Grid>
            <Grid item xs={12}>
              <TextField id="tf_history1" className="w-100" label="大きな病気・メモなど" multiline minRows='4' style={{height:120}} value={history1} onChange={(e)=>handleHistory1Change(e)} />
            </Grid>
            <Grid container justifyContent="space-between">
              {/* 家族情報の編集時のみ、削除ボタンを表示する */}
              {/* {(()=>{
                if (isEdit === true) {
                  // 編集
                  <Grid item>
                    <Button variant="outlined" style={{margin: '0 8px', padding: '5px 20px', color: '#FFF', backgroundColor: '#F66', border: '1px solid #F00'}} onClick={()=>this.handleDelete()}>削除</Button>
                  </Grid>
                  console.log("DeleteButton: true")
                } else {
                  // 新規は何も表示しない
                  console.log("DeleteButton: false")
                }
              })()} */}
              {deleteButton}
              <Grid item>
                <Button variant="outlined" style={{margin: '0 8px'}} color="secondary" onClick={()=>handleGoBack()}>キャンセル</Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" style={{margin: '0 8px', padding: '5px 20px'}} color="primary" disabled={isSubmitting} onClick={()=>handleRegistClick()}>
                  登録
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </div>
    </React.Fragment>
  )
}
